import React from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { DataSourceMetricType } from '@/pages/home/pages/home/components/DataSource';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { toActiveUsersTag, toActiveUsersTagCN } from '@/pages/intelligence/utils/common';
import { useIntl } from 'umi';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

interface DAUColumnType {
  key: string;
  title: string;
  dataSource: DataSourceMetricType | 'ogdb'; // 'appannie' | 'sensortower' | 'ogdb';
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: string;
  tipText?: React.ReactNode;
  width?: number;
}

export const OverviewMetricColumn = (params: DAUColumnType) => {
  const {
    key,
    title,
    sortMetric,
    currentSortKey,
    currentSortValue,
    onSortChage,
    dataSource,
  } = params;

  const { formatMessage } = useIntl();
  const dataSourceIcon = getDataSourceIcon(dataSource);

  return {
    key,
    width: 180,
    align: 'center',
    header: () => {
      return (
        <CloumsCenter width={180} align={'right'}>
          <SortBy
            title={title}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            svgIcon={dataSourceIcon}
            list={[
              {
                key: `${key}_0`,
                sortMetric,
                text: title,
                title,
                ratioType: 0,
              },
              {
                key: `${key}_1`,
                sortMetric,
                text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
                title: title === 'Revenue($)' ? 'Revenue($)%' : `${title}(%)`,
                ratioType: 1,
              },
            ]}
            onChange={onSortChage}
            svgTip={
              <DataSourceBubbleInfo
                dataOfDom={title}
                comesFormDom={
                  <>
                    <img src={getDataSourceIcon(dataSource)} />
                    {DATASOURCE_NAME[dataSource] || dataSource}
                  </>
                }
                dataSource={dataSource}
              />
            }
          />
        </CloumsCenter>
      );
    },
    render: (cvm: any) => {
      const metric = cvm[sortMetric];
      const value = valueFormat(metric?.value);
      const growthDataObj = growthFormat({
        value: metric?.ratio,
        valueType: 'pointValue',
        hasPoint: 'lessThanOne',
        fixedNum: 2,
        maxNumber: 99999,
      });
      return (
        <CloumsCenter width={180} align={'right'}>
          <TableShowData
            maxNumber={'99999+%'}
            value={value}
            type={growthDataObj?.type}
            growth={growthDataObj?.value}
          />
        </CloumsCenter>
      );
    },
  };
};

export const dauTitle = (dateType: string) => {
  return {
    title: toActiveUsersTag[dateType] || 'DAU',
    titleCN: toActiveUsersTagCN[dateType] || '日活跃玩家数',
    key: 'dau',
  };
};

export const revenueTitle = {
  title: 'Revenue($)',
  titleCN: '收入(美元)',
  key: 'revenue',
};
export const downloadTitle = {
  title: 'Downloads',
  titleCN: '下载',
  key: 'downloads',
};
